<template>
    <div class="main-content">
        <alert ref="alert"></alert>

        <section class="section">
            <div class="sec-cst section-header bdr-20 mt-4">
                <router-link class="back-sec" :to="{name:'administrator'}">
                    <i class="uil uil-arrow-left"></i>
                </router-link>
                <h1 class="mt-0">
                    {{this.$route.meta.title}}
                </h1>
                <div class="section-header-breadcrumb">
                    <div class="button-modal text-right">
                        <button v-on:click="validationForm()" type="button" class="btn btn-new"  v-bind:class="loading ? 'btn-progress' : ''">
                            Save Data
                        </button>
                    </div>
                </div>
            </div>
            <div class="section-body mt-4">
                
                <ValidationObserver ref="form" class="form-cst">

                    <div class="row mt-4">
                        <div class="col-md-8">
                            <div class="card bdr-20">
                                <div class="card-body">
                                   
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Name Administrator</label>
                                            <input v-model="formdata.name" type="text" class="form-control" name="name">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Username</label>
                                            <input v-model="formdata.username" type="text" class="form-control" name="name">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <validation-provider v-if="!formdata.id" name="confirm" rules="required|min:8" v-slot="{ errors }">
                                        <div class="form-group">
                                            <div class="d-block">
                                                <label for="password" class="control-label">Password</label>
                                            </div>
                                            <input id="password" type="password" v-model="formdata.password" class="form-control" name="password">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <validation-provider v-if="formdata.id" name="confirm" v-slot="{ errors }">
                                        <div class="form-group">
                                            <div class="d-block">
                                                <label for="password" class="control-label">Password</label>
                                            </div>
                                            <input id="password" type="password" v-model="formdata.password" class="form-control" name="password2">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <validation-provider rules="required|password:@confirm" v-slot="{ errors }" v-if="formdata.password !== ''">
                                        <div class="form-group">
                                            <div class="d-block">
                                                <label for="confirm" class="control-label">Confirmation Password</label>
                                            </div>
                                            <input id="confirm" type="password" v-model="formdata.confirmation" class="form-control" name="confirm">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                
                                </div>
                            </div>  
                          
                        </div>
                        <div class="col-md-4">
                            <div class="card bdr-20">
                                <div class="card-body">
                                    <validation-provider v-if="!formdata.photo_url" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                        <div class="form-group">
                                            <div class="mb-1">
                                                <label>Administrator Photo</label>
                                            </div>
                                            <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD PHOTO</div>
                                            </div>
                                            <input ref="inputImage" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload"
                                                    accept="image/jpeg,image/png,image/jpg" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                    
                                    <div class="form-group" v-if="formdata.photo_url">   
                                        <div class="mb-1">
                                            <label>Administrator Photo</label>
                                        </div> 
                                        <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Change Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="formdata.photo_url" class="w-100 img-responsive img-prf-up">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </ValidationObserver>

            </div>
        </section>

    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
    import { mapState, mapActions, mapMutations} from 'vuex'
    import Alert from "../../components/Alert.vue";

    extend('password', {
        params: ['target'],
        validate(value, { target }) {
            return value === target;
        },
        message: 'Confirmation Password Not Same'
    });

    export default {
        data(){
            return{
                photo_file:'',
                loading:false,
            }
        },
        mounted(){
            if(this.$route.name == 'administrator-edit' && this.formdata.id == ''){
                this.editAdmins(this.$route.params.id)
            }
        },
        watch:{
            errors:function(val){
                if(val.username){
                    this.$refs.alert.showAlert('warning','The username you used already exists')
                    this.loading = false
                }
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Alert,
        },
        computed:{
            ...mapState('AdminControl', {
                formdata: state => state.formdata,
                errors: state => state.errors,
            }),
        },
        methods:{
            ...mapActions('AdminControl', ['createAdmins','updateAdmins','editAdmins']),
            ...mapMutations('AdminControl', ['CLEAR_FORM']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formdata.photo_url = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formdata.photo_url = ''
            },
            validationForm: function() {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{

                        var formData = new FormData();
                        formData.append('name', this.formdata.name);
                        formData.append('username', this.formdata.username);
                        formData.append('password', this.formdata.password ? this.formdata.password : '');
                        
                        if(this.photo_file){
                            formData.append('photo', this.photo_file);
                        }
                        this.loading = true
                        
                        if(this.$route.name == 'administrator-add'){

                            this.createAdmins(formData).then(() => {
                                this.loading = false
                                this.$refs.alert.showAlert('success','Successfully added administrator')
                                this.photo_file = ''
                                this.$refs.form.reset();
                                this.CLEAR_FORM()
                            }) 

                        }else if(this.$route.name == 'administrator-edit'){

                            formData.append("_method", "put");
                            this.updateAdmins({id:this.$route.params.id,formData:formData}).then(() => {
                                this.loading = false
                                this.$refs.alert.showAlert('success','Successfully edited administrator')
                                this.formdata.password = ''
                                this.formdata.confirmation = 
                                this.$refs.form.reset();
                                this.photo_file = ''
                            }) 

                        }
                       
                    }
                });
            },
        },
        beforeRouteLeave (to, from, next) {
            this.CLEAR_FORM()
            next();
        }
    }

</script>